/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Platí určitá vyloučení. Kódy slev nejsou platné pro nákup dárkových karet. A nemohou být kombinovány s jinými promocními kódy.`
};

const da_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Visse undtagelser gælder. Rabatkoder gælder ikke for gavekort og kan ikke kombineres med andre rabatkoder.`
};

const de_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Einige Ausnahmen gelten. Rabattcodes sind nicht für den Kauf von Geschenkkarten gültig und können nicht mit anderen Codes kombiniert werden.`
};

const en_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Certain exclusions apply. Discount codes are not valid for the purchase of gift cards. And they cannot be combined with other discount codes.`
};

const es_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Se aplican algunas exclusiones. Los códigos promocionales no son válidos para la compra de tarjetas regalo. Y no se pueden combinar con otros códigos promocionales.`
};

const fr_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Certaines exclusions s'appliquent. Les codes promo ne sont pas valables pour l'achat de cartes cadeaux. Et ils ne peuvent pas être combinés avec d'autres codes promotionnels.`
};

const hu_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Egyes kizárások alkalmaznak. A promóciós kódok nem érvényesek az ajándékkártya vásárlásához. És nem kombinálhatók más promóciós kódokkal.`
};

const it_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Alcune esclusioni si applicano. I codici sconto non sono validi per l'acquisto di carte regalo e non sono cumulabili con altri codici promozionali.`
};

const nl_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Sommige uitzonderingen zijn van toepassing. Kortingscodes zijn niet geldig voor cadeaubonnen en kunnen niet worden gecombineerd met andere codes.`
};

const pl_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Obowiązują pewne wyłączenia. Kody nie dotyczą zakupu kart podarunkowych i nie można ich łączyć z innymi kodami.`
};

const pt_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Algumas exclusões se aplicam. Os códigos promocionais não são válidos para a compra de cartões-presente. E não podem ser combinados com outros códigos promocionais.`
};

const sv_discount_codes_exclusions = /** @type {(inputs: {}) => string} */ () => {
	return `Vissa undantag gäller. Rabattkoder gäller inte för presentkort och kan inte kombineras med andra koder.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_exclusions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_exclusions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_exclusions", locale)
	if (locale === "cs") return cs_discount_codes_exclusions(inputs)
	if (locale === "da") return da_discount_codes_exclusions(inputs)
	if (locale === "de") return de_discount_codes_exclusions(inputs)
	if (locale === "en") return en_discount_codes_exclusions(inputs)
	if (locale === "es") return es_discount_codes_exclusions(inputs)
	if (locale === "fr") return fr_discount_codes_exclusions(inputs)
	if (locale === "hu") return hu_discount_codes_exclusions(inputs)
	if (locale === "it") return it_discount_codes_exclusions(inputs)
	if (locale === "nl") return nl_discount_codes_exclusions(inputs)
	if (locale === "pl") return pl_discount_codes_exclusions(inputs)
	if (locale === "pt") return pt_discount_codes_exclusions(inputs)
	return sv_discount_codes_exclusions(inputs)
};
export { discount_codes_exclusions as "discount_codes.exclusions" }